<template>
    <!-- 弹窗遮罩 -->
    <div class="lite_popup" v-show="show">
        <!-- 弹窗 -->
        <div class="lite_popup_box">
            <!-- 加载中 -->
            <div class="lite-version-loading" v-show="loadingVersions"></div>
            <!-- 标题栏 -->
            <div class="lite_popup_title">
                <!-- 标题 -->
                <span>{{ $t('language.cloudBackup.restore') }}</span>
                <!-- 关闭图标 -->
                <div class="icon white-close dialog-close" @click="close()"></div>
            </div>
            <!-- 内容 -->
            <div class="lite_popup_content">
                <!-- 选择版本 -->
                <div class="select-desc">{{$t('language.cloudBackup.selectVersions')}}</div>
                <el-select class="down_menu_items" popper-class="down_menu_item" size="small" v-model="version" placeholder=" ">
                    <el-option :label="formatDate(version)" :value="version+''" v-for="version in versions" :key="version"></el-option>
                </el-select>
                <span v-if="version" class="lite_backup_version_details" @click="loadVersionInfo">
                    <span class="lite_backup_version_details_icon"></span>
                    <span>{{ $t('language.imageSaver.view') }}</span>
                </span>
                <!-- 换行 -->
                <br/>
                <!-- 同名处理 -->
                <div class="select-desc">{{$t('language.cloudBackup.restoreOptions')}}</div>
                <el-select class="down_menu_items" popper-class="down_menu_item" size="small" v-model="sameName" placeholder=" ">
                    <el-option :label="$t('language.cloudBackup.keepLatest')" value=""></el-option>
                    <el-option :label="$t('language.popup.overWrite')" value="overwrite"></el-option>
                    <el-option :label="$t('language.popup.skipFile')" value="skip"></el-option>
                    <el-option :label="$t('language.popup.rename')" value="rename"></el-option>
                </el-select>
                <!-- 还原位置选择 -->
                <el-radio-group v-model="restoreLocation" class="restore-location">
                    <el-radio label="old">{{ $t('language.cloudBackup.restoreOriginal') }}</el-radio>
                    <el-radio label="new">{{ $t('language.cloudBackup.restoreNewLocation') }}</el-radio>
                </el-radio-group>
                <!-- 换行 -->
                <br/>
                <!-- 还原位置 -->
                <div class="restore-path" v-if="restoreLocation=='old'">
                    <div v-if="data">
                        <div :class="'restore-drive-icon drive-icon-' + getDrive(data.fdid).type"></div>
                        <span>{{ getDrive(data.fdid).name + getNodePath(data.param.from) }}</span>
                    </div>
                </div>
                <div class="restore-path" v-if="restoreLocation=='new'" style="cursor: pointer;" @click="selectTaskTo()">
                    <div v-if="newLocationDid">
                        <div :class="'restore-drive-icon drive-icon-' + getDrive(newLocationDid).type"></div>
                        <span>{{ getDrive(newLocationDid).name + getNodePath(newLocationNode) }}</span>
                    </div>
                    <button v-else>{{$t('language.shareTransfers.transferDescription')}}</button>
                </div>
            </div>
            <!-- 底部 -->
             <div class="lite_popup_footer">
                <!-- 按钮 -->
                <button @click="close()" class="white">{{ $t('language.common.cancel') }}</button>
                <button v-if="version && (restoreLocation=='old' || (restoreLocation=='new'&&newLocationDid))" @click="ok()">{{ $t('language.cloudBackup.restore') }}</button>
            </div>
            <!-- 任务目标 -->
            <liteSelect ref="taskToTree" :showCheckbox="false" :showDBDrive="false" :showFileNode="false" :showNewFolder="true" @selectDone="selectDoneTo" />
            <!-- 已备份某版本文件列表 -->
            <liteBackupFiles ref="backupFiles" :files="versionFiles" />
        </div>
    </div>
</template>

<script>
import liteBackupFiles from "@/components/workspace/lite_backup_files";
import liteSelect from "@/components/workspace/lite_select";
import commonUtils from "@/js/workspace/common_util.js";
import requestUtils from '@/js/request_util.js';
import { Message } from "element-ui";

export default {
    props: {
        data: Object,
    },
    components: {
        liteSelect,
        liteBackupFiles,
    },
    data() {
        return {
            // 是否显示弹窗
            show: false,
            // 是否正在加载版本
            loadingVersions: false,
            // 同名处理
            sameName: '',
            // 所有版本
            versions: [],
            // 已选择版本
            version: '',
            // 新旧位置标识
            restoreLocation: 'old',
            // 新位置云盘ID
            newLocationDid: '',
            // 新位置节点
            newLocationNode: null,
            // 创建任务参数
            taskParam: null,
            // 创建任务中
            createTasking: false,
            // 版本具体文件信息
            versionFiles: [],
        };
    },
    methods: {
        // 选择任务目标
        selectTaskTo() {
            this.$refs.taskToTree.show = true;
        },
        // 任务目标选择完成
        selectDoneTo(data) {
            // 选择结果赋值
            this.newLocationDid = data.did;
            this.newLocationNode = data.node;
        },
        // 获取节点路径
        getNodePath(node) {
            let path = '';
            let arr = this.getNodeArr(node);
            for (let i = 0; i < arr.length; i++) {
                let item = arr[i];
                path += '/' + item.name;
            }
            return path;
        },
        // 获取节点和父
        getNodeArr(node) {
            let arr = [];
            while (node) {
                arr.push(node);
                node = node.parent;
            }
            return arr.reverse();
        },
        // 获取云盘
        getDrive(id) {
            for (let i = 0; i < this.$store.state.drives.length; i++) {
                let drive = this.$store.state.drives[i];
                if (drive.id === id) {
                    return drive;
                }
            }
            return null;
        },
        // 格式化时间
        formatDate(value) {
            if (!value) return '';
            const date = new Date(value);
            if (isNaN(date.getTime())) return '';
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        async ok() {
            // 创建任务参数
            this.taskParam = {
                type: 'restore',
                name: this.data.name + ' Restore ' + this.formatDate(parseInt(this.version)) + ' to ' + this.restoreLocation,
                fdid: this.data.tdid,
                tdid: (this.restoreLocation=='old' ? this.data.fdid : this.newLocationDid),
                param: {
                    from: this.data.param.to,
                    to: (this.restoreLocation=='old' ? this.data.param.from : this.newLocationNode),
                    options: {
                        listThread: commonUtils.getUser().vip ? 3 : 1,
                        runThread: commonUtils.getUser().vip ? 10 : 2,
                        email: '',
                        cron: '',
                        sameName: this.sameName,
                        excludeNames: [],
                        allowedExtensions: [],
                        type: 'restore',
                        onlyAdd: false,
                        schedules: {disabled:true},
                        delete: false,
                        keepDate: false,
                        logFile: false,
                        inOneFolder: false,
                        syncMode: '',
                        version: this.data.id + '-' + this.version,
                    }
                }
            }
            await this.createTask();
            this.close();
            this.$emit('ok');
        },
        // 创建任务
        createTask(callback) {
            if (this.createTasking) return;
            // 未设置任务名称
            if (!this.taskParam.name) {
                Message.error("Please input task name");
                return;
            }
            // 未选择源
            if (!this.taskParam.fdid) {
                Message.error("Please select source cloud");
                return;
            }
            // 未选择目标
            if (!this.taskParam.tdid) {
                Message.error("Please select destination cloud");
                return;
            }
            // 非传输任务源只能是文件夹
            let from = this.taskParam.param.from;
            if (from && !from.dir && this.taskParam.type != 'tran' && this.taskParam.type != 'copy') {
                Message.error("The source of non-transfer tasks can only be a folder");
                return;
            }
            // 目标只能是文件夹
            let to = this.taskParam.param.to;
            if (to && !to.dir) {
                Message.error("Task targets can only be folders");
                return;
            }
            // 快捷创建任务：设置类型与任务类型匹配
            this.taskParam.param.options.type = this.taskParam.type;
            // 开始创建任务
            return new Promise((resolve, reject) => {
                this.createTasking = true;
                this.sendRequest("/task/create", this.taskParam, () => {
                    this.createTasking = false;
                    if (callback) {
                        callback();
                    } else {
                        Message.success("Task created successfully");
                        this.listTasks();
                    }
                    resolve();
                });
            });
        },
        // 获取任务列表
        listTasks(callback) {
            this.sendRequest("/task/list", {}, (data) => {
                this.$store.state.tasks = data;
                if (callback) callback();
            })
        },
        clearPageChoose() {
            // 有用，不能删除
        },
        init() {
            // 初始化数据
            this.version = '';
            this.versions = [];
            this.sameName = '';
            this.restoreLocation = 'old';
            this.newLocationDid = '';
            this.newLocationNode = null;
            this.show = true;
            // 获取版本列表
            this.loadingVersions = true;
            this.sendRequest('/task/restoreVersions', { id: this.data.id }, (res) => {
                this.versions = res;
                if (res.length > 0) {
                    this.version = res[0] + '';
                }
                this.loadingVersions = false;
            }, () => {
                this.loadingVersions = false;
            });
        },
        loadVersionInfo() {
            this.loadingVersions = true;
            this.sendRequest('/task/versionInfo', { id: this.data.id, version: this.version }, (res) => {
                this.versionFiles = res;
                this.loadingVersions = false;
                if (this.versionFiles.length > 0) {
                    this.$refs.backupFiles.show = true;
                } else {
                    Message.warning("No files found in this version");
                }
            }, () => {
                this.loadingVersions = false;
            });
        },
        close() {
            this.show = false;
        },
        // 发送Lite请求
        sendRequest(path, data, callback, errCallback) {
            requestUtils.doLiteRequest(path, data)
                .then(res => {
                    let code = res.code
                    let msg = res.msg
                    if (msg == undefined) {
                        msg = res.message;
                    }
                    if (code == 200) {
                        // 请求成功
                        if (callback) {
                            callback(res.data);
                        }
                    } else if (code == 400) {
                        // 请求失败
                        Message.warning(msg);
                        if (errCallback) {
                            errCallback()
                        }
                    } else {
                        if (msg == "Unauthorized") {
                            // 未登录
                            location.href = location.host.includes("localhost") ? "http://localhost:8080/share/123" : "https://" + location.host + "/sign"
                        } else {
                            // 服务器异常
                            Message.error(msg);
                            if (errCallback) {
                                errCallback()
                            }
                        }
                    }
                }, err => {
                    // 请求异常
                    Message.error(err);
                    if (errCallback) {
                        errCallback()
                    }
                });
        }
    }
};
</script>

<style>
/* 弹窗宽度 */
.lite_popup_box {
    width: 600px;
}
/* 还原位置选择 */
.restore-location {
    margin-top: 20px;
}
.restore-location>.el-radio {
    display: block;
    margin-top: 15px;
}
.restore-location .el-radio__input.is-checked+.el-radio__label {
    color: #606266;
}
/* 还原位置 */
.restore-path {
    color: #606266;
    margin-top: 30px;
    display: inline-block;
}
/* 云盘图标 */
.restore-drive-icon {
    width: 30px;
    height: 30px;
    background-size: 100%;
    display: inline-block;
    vertical-align: middle;
}
/* 下拉菜单描述 */
.select-desc {
    color: #606266;
    display: inline-block;
    margin-right: 10px;
    min-width: 150px;
}
/* 让loading在内部显示 */
.lite_popup_content {
    position: relative;
}
/* 加载备份版本信息 */
.lite-version-loading {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 40px;
    width: 100%;
    height: calc(100% - 40px);
    background: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}
.lite-version-loading::after {
    content: "";
    width: 48px;
    height: 48px;
    border: 4px solid #DCE4F5;
    border-top-color: #5562B4;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}
@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
/* 显示版本信息 */
.lite_backup_version_details {
    margin-left: 20px;
    cursor: pointer;
    color: #5562B4;
}
.lite_backup_version_details:hover {
    text-decoration: underline;
}
.lite_backup_version_details_icon {
    background-image: url("../../assets/images/vectorImg/icon_Preview.svg");
    width: 16px;
    height: 16px;
    display: inline-block;
    position: relative;
    top: 2px;
}
/* 下拉菜单 */
.down_menu_items {
    width: 300px;
}
.down_menu_items .el-input__suffix {
    height: 32px;
    top: 10px;
}
.down_menu_item .el-select-dropdown__item {
    color: #6f7886;
    font-size: 12px;
}
.down_menu_item .el-select-dropdown__item.selected {
    color: #6f7886;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_restore.vue